import { getAppConfigValue } from "@elliemae/pui-app-sdk";
const startRefreshTokenProcess = (startingRefreshToken, callbacks) => {
  let currentRefreshToken = startingRefreshToken;
  let hardTimeoutOffsetCancelToken = null;
  let hardTimeoutCancelToken = null;
  const refreshFn = async () => {
    if (hardTimeoutOffsetCancelToken) {
      clearTimeout(hardTimeoutOffsetCancelToken);
    }
    if (hardTimeoutCancelToken) {
      clearTimeout(hardTimeoutCancelToken);
    }
    window.__previouslyRefreshedTokens = window.__previouslyRefreshedTokens ?? /* @__PURE__ */ new Set();
    if (window.__previouslyRefreshedTokens.has(currentRefreshToken)) {
      return;
    }
    window.__previouslyRefreshedTokens.add(currentRefreshToken);
    const url = `${getAppConfigValue(
      "serviceEndpoints.ppeServices"
    )}/opaque-token/refresh`;
    const refreshTokenOffset = getAppConfigValue(
      "ppe.refreshTokenOffset"
    );
    const refreshTokenOffsetHardTimeout = getAppConfigValue(
      "ppe.refreshTokenOffsetHardTimeout"
    );
    const payload = {
      RefreshToken: currentRefreshToken
    };
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    let {
      token,
      refreshToken,
      ttl,
      hardLimit
    } = await response.json();
    if (localStorage.getItem("testTokenHardLimit") && getAppConfigValue("laneTag") !== "pr1") {
      hardLimit = new Date(localStorage.getItem("testTokenHardLimit"));
    }
    if (!token || !refreshToken || !ttl || !hardLimit) {
      throw new Error("Invalid response from token refresh endpoint");
    }
    currentRefreshToken = refreshToken;
    callbacks?.newToken?.(token, currentRefreshToken);
    setTimeout(
      refreshFn,
      new Date(ttl).getTime() - Date.now() - refreshTokenOffset
    );
    hardTimeoutOffsetCancelToken = setTimeout(() => {
      callbacks?.hardLimitOffset?.();
    }, new Date(hardLimit).getTime() - Date.now() - refreshTokenOffsetHardTimeout);
    hardTimeoutCancelToken = setTimeout(() => {
      callbacks?.hardLimit?.();
    }, new Date(hardLimit).getTime() - Date.now());
  };
  refreshFn();
};
export {
  startRefreshTokenProcess
};
